import React from 'react';
import Header from '../common/Header';
export default function ArabicHeader(){return <Header language="ar"/>;}
